import { defineComponent as _defineComponent } from 'vue'
import CompareSimilarProducts from './CompareSimilarProducts.vue';
import VIntersectionObserver from 'Src/js/components/VIntersectionObserver.vue';
import { computed, PropType, ref } from 'vue';
import { IListableProductJson } from 'JS/types/Product';
import { useBreakpoints } from 'JS/composables/breakpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'LazyCompareSimilarCarousel',
  props: {
	currentProduct: {
		type: Object as PropType<IListableProductJson>,
		required: true
	}
},
  emits: ["add-to-cart"],
  setup(__props, { emit }: { emit: ({
	(event: 'add-to-cart'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const loadCarouselData = ref(false);

const { isMobile } = useBreakpoints();
const intersectionObserverOptions = computed((): IntersectionObserverInit => {
	const rootMargin = isMobile.value
		? '300px' // start loading a bit sooner on mobile
		: '100px';

	return {
		root: null,
		rootMargin,
	};
});

return { __sfc: true,props, emit, loadCarouselData, isMobile, intersectionObserverOptions, CompareSimilarProducts, VIntersectionObserver }
}

})